function ChevronLeft() {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="36" height="36" rx="18" fill="white" />
      <path
        d="M20.6569 12.2929C20.2663 11.9024 19.6332 11.9024 19.2426 12.2929L14.2929 17.2426C13.9024 17.6332 13.9024 18.2663 14.2929 18.6569L19.2426 23.6066C19.6332 23.9971 20.2663 23.9971 20.6569 23.6066C21.0474 23.2161 21.0474 22.5829 20.6569 22.1924L16.4142 17.9497L20.6569 13.7071C21.0474 13.3166 21.0474 12.6834 20.6569 12.2929Z"
        fill="#323232"
      />
    </svg>
  );
}

export default ChevronLeft;